module.exports = __webpack_public_path__ + "media/Video 21.8235584e.mp4";